module.exports = __webpack_public_path__ + "img/close-black.d8b9dd84.svg";